import { getFormVariant } from '../Requests/AppRequests';

function prevPageObject(appState, currentPage) {
  const { variantObject: { pages } } = appState;
  let previousPages = {};
  let currentPageMeet = false;
  Object.keys(pages).forEach((pageName) => {
    if (pageName === currentPage.currentPage) (currentPageMeet = true);
    if (!currentPageMeet) {
      previousPages = { ...previousPages, [pageName]: pages[pageName] };
      return previousPages;
    }
    return null;
  });
}

const switchVariant = (originalVariant, appState, currentPage) => {
  const newVariantWithPreviousPage = {
    ...originalVariant,
    pages: { ...prevPageObject(appState, currentPage), ...originalVariant.pages },
  };
  return newVariantWithPreviousPage;
};

const switchToOriginalVariant = async (
  formNumber,
  variant = 1,
  appState = {},
  currentPage = '',
  setCurrentPage = () => {},
  updateAppState = () => {},
) => {
  const originalVariant = await getFormVariant(formNumber, variant, appState.uuid);

  setCurrentPage({ currentPage: Object.keys(originalVariant.pages)[1] });
  return updateAppState({
    variantObject: switchVariant(originalVariant, appState, currentPage),
    form: formNumber,
    variant_number: variant,
  });
};

export default switchToOriginalVariant;
